import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getAdminOrdersGroupWithUsers
} from '../../store/action/order';
import AdminOrderTable from '../../components/tables/AdminOrderTable';
import {CSVLink} from "react-csv";

const AdminGroupOrders = (props) => {
    const { token } = isAuthenticated();
    const [show, setShow] = useState(false);
    const [loading, setLoading ] = useState(true);
    const [postpaidOrders, setPostpaidOrders] = useState([]);
    const [prepaidOrders, setPrepaidOrders] = useState([]);
    const [downloadOrders, setDownloadOrders] = useState([]);


    useEffect(() => {
        _fetchData()
    }, []);

    const convert = (i) => {
        return {
            userId:i.userId,
            name:i.name,
            organization:i.organization,
            paymentMethod: i.payment_method,
            placed:i.placed,
            confirmed:i.confirmed,
            allocated:i.allocated,
            pickingUp:i.picking_up,
            picked:i.picked,
            droppingOff:i.dropping_off,
            onHold:i.on_hold,
            total:i.total
        }
    }

    const _fetchData = async () => {
        const res = await getAdminOrdersGroupWithUsers(token);
        if (res.success) {
            const orders = res.orders;
            const postpaidOrders = orders.reduce((r,i) => {
                if (i.payment_method === 'credit') {
                    r.push(convert(i))
                }
                return r;
            },[])
            const prepaidOrders = orders.reduce((r,i) => {
                if (i.payment_method !== 'credit') {
                    r.push(convert(i))
                }
                return r;
            },[])
            setPostpaidOrders(postpaidOrders)
            setPrepaidOrders(prepaidOrders)
        }
    }

    const card = (item) => {
        return (
            <div className="row">
                <div className="col-4">
                    <b>{item.organization} </b><small> {item.name}</small>
                </div>
                <div className="col-8">
                    <div className="row">
                        <span className="col badge"> {item.total}</span>
                        <span className="col badge"> {item.placed}</span>
                        <span className="col badge"> {item.confirmed}</span>
                        <span className="col badge"> {item.allocated}</span>
                        <span className="col badge"> {item.pickingUp}</span>
                        <span className="col badge"> {item.picked}</span>
                        <span className="col badge"> {item.droppingOff}</span>
                        <span className="col badge"> {item.onHold}</span>
                    </div>
                </div>
            </div>
        )
    }

    const header = () => {
        return (
            <div className="row">
                <div className="col-4"/>
                <div className="col-8">
                    <div className="row">
                        <span className="col badge badge-success">total</span>
                        <span className="col badge">placed</span>
                        <span className="col badge">confirmed</span>
                        <span className="col badge">allocated</span>
                        <span className="col badge">pickingUp</span>
                        <span className="col badge">picked</span>
                        <span className="col badge">droppingOff</span>
                        <span className="col badge">onHold</span>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="p-4">
            <h2>Orders</h2>
            <br/>
            <h4>Postpaid</h4>
            { header() }
            {
                postpaidOrders.map(i => card(i))
            }
            <hr/>
            <h4>Prepaid</h4>
            { header() }
            {
                prepaidOrders.map(i => card(i))
            }
        </div>
    )
}


export default AdminGroupOrders;

